(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bildzoom"] && !Shopify.designMode) return;
  try {
    (function () {
    /* KEINE ZWISCHENGESPEICHERTEN VERWEISE.

       Die Horcher unten haengen an `document` und ueberleben jedes
       Neuzeichnen -- der Dialog selbst nicht. Im Theme-Editor wird die
       Produktsektion bei jeder Aenderung ersetzt; ein gemerkter Verweis
       zeigt danach auf einen Knoten, den es nicht mehr gibt, und
       showModal() wirft InvalidStateError. Sichtbar nur in der Konsole,
       und der Zoom ist tot.

       Deshalb: bei jedem Oeffnen frisch holen. Ein querySelector kostet
       Mikrosekunden, ein toter Zoom kostet den Kaufgrund. */
    function teile() {
      var dialog = document.querySelector('[data-zoom]');
      if (!dialog || typeof dialog.showModal !== 'function') return null;
      return {
        dialog:  dialog,
        bild:    dialog.querySelector('[data-zoom-bild]'),
        buehne:  dialog.querySelector('[data-zoom-buehne]'),
        hinweis: dialog.querySelector('[data-zoom-hinweis]'),
        zu:      dialog.querySelector('[data-zoom-zu]')
      };
    }
    if (!teile()) return;
    var gross = false;

    function oeffnen(quelle, text) {
      var t = teile(); if (!t) return;
      var dialog = t.dialog, bild = t.bild, buehne = t.buehne, hinweis = t.hinweis;
      /* Immer die groesste verfuegbare Fassung holen. Ein Zoom auf ein
         768px-Bild ist kein Zoom, sondern eine Unschaerfe -- und genau das
         ist gemeint, wenn Baymard "kein ausreichender Zoom" zaehlt. */
      bild.src = quelle.replace(/([?&])width=\d+/, '$1width=2400');
      bild.alt = text || '';
      gross = false;
      buehne.classList.remove('ist-gross');
      hinweis.textContent = dialog.dataset.hinweisRein;
      /* showModal wirft InvalidStateError, wenn der Dialog nicht mehr im
         Dokument haengt -- das passiert im Theme-Editor, sobald die
         Produktsektion neu gezeichnet wird. Ohne diese Pruefung stirbt der
         Zoom dort lautlos, sichtbar nur in der Konsole. */
      if (!dialog.isConnected) return;
      try { dialog.showModal(); } catch (e) { /* schon offen oder entfernt */ }
    }

    function umschalten(ereignis) {
      var t = teile(); if (!t) return;
      var dialog = t.dialog, bild = t.bild, buehne = t.buehne, hinweis = t.hinweis;
      gross = !gross;
      buehne.classList.toggle('ist-gross', gross);
      hinweis.textContent = gross ? dialog.dataset.hinweisRaus : dialog.dataset.hinweisRein;

      if (gross && ereignis) {
        /* Dorthin zoomen, wo geklickt wurde -- nicht in die Bildmitte.
           Wer auf den Bund tippt, will den Bund sehen. */
        var mass = buehne.getBoundingClientRect();
        var x = ((ereignis.clientX - mass.left) / mass.width) * 100;
        var y = ((ereignis.clientY - mass.top) / mass.height) * 100;
        bild.style.transformOrigin = x + '% ' + y + '%';
      } else {
        bild.style.transformOrigin = '50% 50%';
      }
    }

    /* Auch diese drei ueber `document`, damit sie einen Sektionswechsel
       ueberleben. Sperre gegen Mehrfachregistrierung, weil das Snippet bei
       einem Neuladen der Sektion erneut ausgewertet werden kann. */
    if (!document.documentElement.dataset.zoomVerdrahtet) {
      document.documentElement.dataset.zoomVerdrahtet = '1';
      document.addEventListener('click', function (e) {
        var t = teile(); if (!t) return;
        if (e.target.closest && e.target.closest('[data-zoom-buehne]')) {
          umschalten(e); return;
        }
        if (e.target.closest && e.target.closest('[data-zoom-zu]')) {
          t.dialog.close(); return;
        }
        /* Klick auf den Hintergrund schliesst. Das <dialog>-Element selbst
           ist die Flaeche ausserhalb des Inhalts. */
        if (e.target === t.dialog) t.dialog.close();
      });
    }

    /* Anmeldung: jedes Element mit data-zoomen oeffnet den Zoom. */
    function ausloesen(ausloeser, ereignis) {
      var quelle = ausloeser.dataset.zoomen ||
                   (ausloeser.querySelector('img') || {}).currentSrc ||
                   (ausloeser.querySelector('img') || {}).src;
      if (!quelle) return;
      ereignis.preventDefault();
      var img = ausloeser.querySelector('img');
      oeffnen(quelle, img ? img.alt : '');
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-zoomen]');
      if (a) ausloesen(a, e);
    });

    /* TASTATUR. Ein <div role="button"> loest bei Enter oder Leertaste
       KEINEN Klick aus -- anders als ein echtes <button>. Wer das
       vergisst, baut ein Bedienelement, das mit der Maus geht und mit der
       Tastatur nicht. Apple, accessibility.md: "Let people use the
       keyboard alone to navigate and interact."
       Leertaste zusaetzlich abfangen, sonst scrollt die Seite darunter weg. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var a = e.target.closest && e.target.closest('[data-zoomen]');
      if (a) ausloesen(a, e);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["groessenfinder"] && !Shopify.designMode) return;
  try {
    /* Groessenfinder. Rechnet aus der hinterlegten Tabelle, nicht aus fest
     eingetippten Zahlen -- aendert Robin die Tabelle, aendert sich die
     Empfehlung mit. Zwei Quellen fuer dieselbe Wahrheit sind eine zu viel. */
  (function () {
    var wurzel = document.querySelector('[data-groessenfinder]');
    if (!wurzel) return;

    var knoten = wurzel.querySelector('[data-gf-tabelle]');
    var tabelle;
    try { tabelle = JSON.parse(knoten.textContent); } catch (e) { return; }
    if (!tabelle || !tabelle.length) return;

    var jeansFeld  = wurzel.querySelector('[data-gf-jeans]');
    var tailleFeld = wurzel.querySelector('[data-gf-taille]');
    var antwort    = wurzel.querySelector('[data-gf-antwort]');
    var anzeige    = wurzel.querySelector('[data-gf-groesse]');
    var grund      = wurzel.querySelector('[data-gf-grund]');
    var uebernehmen = wurzel.querySelector('[data-gf-uebernehmen]');

    /* TAILLE KOMMT ALS ZAHLENPAAR, NICHT MEHR ALS SATZ.

       Hier stand bis zum 09.09.2026 ein Textabgleich auf /^bis/ und /^ab/,
       um die offenen Baender zu erkennen. Das war eine Zeitbombe: sobald
       jemand die Daten uebersetzt haette ("up to 78"), waeren beide
       Bedingungen still falsch geworden. Der Finder haette keinen Fehler
       geworfen, sondern jedem Kunden unter 79 und ueber 99 cm einfach
       KEINE Groesse mehr genannt -- genau den Raendern, an denen
       Groessenunsicherheit am teuersten ist.

       Jetzt kommen taille_von / taille_bis als Zahlen, null heisst offen.
       Nichts daran haengt an einer Sprache.

       Die offenen Raender sind Absicht: wer 68 cm oder 118 cm misst, soll
       eine Antwort bekommen statt ins Leere zu laufen. Die alte Tabelle
       hatte drei echte Luecken (77-80, 87-90, 98-101 cm) -- zusammen 12 von
       37 Zentimetern ohne Groesse. Ein Finder, der bei einem Drittel der
       Kunden schweigt, ist schlechter als keiner. */
    function taillenspanne(zeile) {
      var v = zeile.taille_von, b = zeile.taille_bis;
      if (v == null && b == null) return null;
      return [v == null ? 0 : v, b == null ? 999 : b];
    }

    /* Jeansweiten bleiben ein Textband ("28–30") -- dort stehen keine
       Woerter, nur Zahlen und ein Strich. Halbgeviertstrich UND Minus
       zulassen, sonst schlaegt es still fehl. */
    function spanne(text) {
      var zahlen = String(text).match(/\d+/g);
      return zahlen && zahlen.length === 2
        ? [parseInt(zahlen[0], 10), parseInt(zahlen[1], 10)]
        : null;
    }

    /* WIE WEIT EIN OFFENES BAND WIRKLICH TRAEGT.
       "ab 100" wird intern zu [100, 999]. Damit galt jede Zahl darueber als
       Treffer: bei 120 cm sagte der Finder "XL passt". Laut Herstellerblatt
       geht XL bis 107 cm. Eine Zusage, die 13 cm daneben liegt, ist bei
       40-50 % Retourenquote in Mode teurer als gar keine Antwort.
       Dasselbe unten: "bis 78" ist [0, 78], und bei 60 cm haette S gepasst.

       10 cm ueber beziehungsweise unter dem genannten Wert ist die Grenze,
       ab der wir nicht mehr raten, sondern es sagen. Der Randtext lautet
       genau dafuer: "XL ist unsere Randgroesse. Wenn du unsicher bist,
       schreib uns kurz." Das ist ehrlicher als eine Groesse zu nennen, die
       zurueckkommt. */
    var RANDLUFT = 10;

    function ausTaille(cm) {
      for (var i = 0; i < tabelle.length; i++) {
        var s = taillenspanne(tabelle[i]);
        if (!s) continue;
        var offenNachOben  = s[1] >= 999;
        var offenNachUnten = s[0] <= 0;
        var obergrenze = offenNachOben  ? s[0] + RANDLUFT : s[1];
        var untergrenze = offenNachUnten ? s[1] - RANDLUFT : s[0];

        if (cm >= untergrenze && cm <= obergrenze) {
          return { groesse: tabelle[i].groesse, art: 'treffer', spanne: s };
        }
        /* Innerhalb des offenen Bandes, aber jenseits der Randluft: die
           Groesse stimmt noch, die Zusage nicht mehr. */
        if (offenNachOben && cm > obergrenze) {
          return { groesse: tabelle[i].groesse, art: 'ueber' };
        }
        if (offenNachUnten && cm < untergrenze) {
          return { groesse: tabelle[i].groesse, art: 'unter' };
        }
      }
      /* Zwischen zwei Groessen: zur KLEINEREN raten. Der Bund gibt nach,
         der Halt nicht. Diese Richtung erzeugt weniger Retouren.
         Seit dem 08.09.2026 stossen die Baender lueckenlos aneinander, dieser
         Fall tritt also nicht mehr auf. Der Zweig bleibt als Sicherung, falls
         die Tabelle spaeter wieder mit Luecken gepflegt wird. */
      for (var j = 0; j < tabelle.length - 1; j++) {
        var a = taillenspanne(tabelle[j]), b = taillenspanne(tabelle[j + 1]);
        if (a && b && cm > a[1] && cm < b[0]) {
          return { groesse: tabelle[j].groesse, art: 'zwischen',
                   spanne: a, naechste: tabelle[j + 1].groesse };
        }
      }
      var erste = taillenspanne(tabelle[0]);
      var letzte = taillenspanne(tabelle[tabelle.length - 1]);
      if (erste && cm < erste[0]) return { groesse: tabelle[0].groesse, art: 'unter' };
      if (letzte && cm > letzte[1]) return { groesse: tabelle[tabelle.length - 1].groesse, art: 'ueber' };
      return null;
    }

    function ausJeans(w) {
      for (var i = 0; i < tabelle.length; i++) {
        var s = spanne(tabelle[i].jeans);
        if (s && w >= s[0] && w <= s[1]) {
          return { groesse: tabelle[i].groesse, art: 'treffer', jeans: s };
        }
      }
      return null;
    }

    function text(schluessel) {
      return (wurzel.dataset[schluessel] || '');
    }

    function zeigen(ergebnis, quelle, wert) {
      if (!ergebnis) { antwort.hidden = true; return; }
      antwort.hidden = false;
      anzeige.textContent = ergebnis.groesse;

      var satz;
      if (ergebnis.art === 'zwischen') {
        satz = wurzel.dataset.grundZwischen
          .replace('{wert}', wert).replace('{a}', ergebnis.groesse)
          .replace('{b}', ergebnis.naechste);
      } else if (ergebnis.art === 'unter' || ergebnis.art === 'ueber') {
        /* Zwei Raender, zwei Saetze. Vorher stand bei 62 cm Taille
           woertlich "groesser als XL gibt es im ersten Drop noch nicht" --
           eine Antwort auf eine Frage, die niemand gestellt hat. */
        satz = (ergebnis.art === 'ueber'
                  ? text('grundRandOben')
                  : text('grundRandUnten')).replace('{g}', ergebnis.groesse);
      } else if (quelle === 'jeans') {
        satz = wurzel.dataset.grundJeans
          .replace('{wert}', wert).replace('{g}', ergebnis.groesse);
      } else {
        /* OFFENE BAENDER BRAUCHEN EIGENE SAETZE.
           Die Tabelle sagt "bis 78" und "ab 100". Intern werden daraus die
           Spannen [0,78] und [100,999] -- Rechenhilfen, keine Angaben fuer
           Menschen. Eingesetzt in "(Taille {von}–{bis} cm)" kam dabei
           woertlich "(Taille 0–78 cm)" und "(Taille 100–999 cm)" heraus.
           Beides stand so auf der Seite und beides ist Unsinn: niemand hat
           null Zentimeter Taille, und 999 ist eine Rechenmarke.
           Deshalb hier drei Faelle statt einem. */
        var von = ergebnis.spanne[0], bis = ergebnis.spanne[1];
        if (von <= 0) {
          satz = text('grundTailleBis')
            .replace('{wert}', wert).replace('{g}', ergebnis.groesse)
            .replace('{bis}', bis);
        } else if (bis >= 999) {
          satz = text('grundTailleAb')
            .replace('{wert}', wert).replace('{g}', ergebnis.groesse)
            .replace('{von}', von);
        } else {
          satz = wurzel.dataset.grundTaille
            .replace('{wert}', wert).replace('{g}', ergebnis.groesse)
            .replace('{von}', von).replace('{bis}', bis);
        }
      }
      grund.textContent = satz;

      /* Die Empfehlung direkt in die Groessenwahl uebernehmen. Ohne diesen
         Knopf muss der Kunde die Antwort merken und selbst suchen -- genau
         dort geht die gewonnene Sicherheit wieder verloren. */
      var passendes = document.querySelector(
        '.pdp__groessen input[type=radio][value="' + ergebnis.groesse + '"]');
      if (passendes) {
        uebernehmen.hidden = false;
        uebernehmen.onclick = function () {
          passendes.checked = true;
          passendes.dispatchEvent(new Event('change', { bubbles: true }));
          passendes.closest('.wahl').scrollIntoView({
            block: 'center',
            behavior: document.documentElement.classList.contains('reduced-motion')
              ? 'auto' : 'smooth'
          });
        };
      } else {
        uebernehmen.hidden = true;
      }
    }

    if (jeansFeld) jeansFeld.addEventListener('change', function () {
      var w = parseInt(jeansFeld.value, 10);
      if (!w) { antwort.hidden = true; return; }
      if (tailleFeld) tailleFeld.value = '';
      zeigen(ausJeans(w), 'jeans', w);
    });

    if (tailleFeld) tailleFeld.addEventListener('input', function () {
      var cm = parseInt(tailleFeld.value, 10);
      /* Erst ab zwei Ziffern rechnen -- sonst springt die Antwort bei jedem
         Tastendruck und wirkt nervoes. */
      if (!cm || cm < 50) { antwort.hidden = true; return; }
      if (jeansFeld) jeansFeld.value = '';
      zeigen(ausTaille(cm), 'taille', cm);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["groessentabelle"] && !Shopify.designMode) return;
  try {
    /* cm <-> Zoll. Gerechnet, nicht gepflegt: die Tabelle steht in cm, die
     Zoll-Werte entstehen daraus. Waeren beide von Hand gepflegt, driften sie
     -- und eine falsche Groessenangabe kostet eine Retoure, nicht nur
     Vertrauen. */
  (function () {
    var wurzel = document.querySelector('[data-gtab]');
    if (!wurzel) return;

    var zellen = wurzel.querySelectorAll('[data-taille]');
    var schalter = wurzel.querySelectorAll('[data-einheit]');
    var kopfCm = wurzel.querySelector('[data-kopf-cm]');
    var kopfIn = wurzel.querySelector('[data-kopf-in]');

    /* Kein Umrechnen im Browser mehr: beide Saetze stehen fertig und in der
       richtigen Sprache in den data-Attributen. Der alte Ziffernersatz
       rechnete zwar richtig, liess aber die deutschen Woerter stehen. */

    schalter.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var zoll = knopf.dataset.einheit === 'in';
        schalter.forEach(function (k) {
          var an = k === knopf;
          k.classList.toggle('ist-an', an);
          k.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        zellen.forEach(function (z) {
          z.textContent = zoll ? z.dataset.tailleIn : z.dataset.taille;
        });
        if (kopfCm) kopfCm.hidden = zoll;
        if (kopfIn) kopfIn.hidden = !zoll;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
